/** 实时追踪页面接口功能
 */
// 设备状态字典函数
function lImmediatelyStatusDic(e) {
  if (e === 0) {
    return "静止";
  } else if (e === 1) {
    return "行驶";
  } else if (e === 2) {
    return "休眠";
  } else if (e === 3) {
    return "离线";
  } else {
    return "未知";
  }
}

const trackingCtl = {
  /** 根据设备id查询该设备实时位置信息、该设备信息、该设备所属组织信息、可查看多个设备、至少选择一个设备查看、列表无分页
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getLocationByDevId: function (_this, url, devId, BMap, BMapLib) {
    _this
      .$axios({
        method: 'post',
        url: url,
        data: {
          devIdList: [devId]
        },
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then(async function (res) {
        if (res.data.code === 200) {
          if (!res.data.data.pag[0].lLonBd09 && !res.data.data.pag[0].lLatBd09) {
            _this.$message({
              message: '该设备未定位',
              type: 'warning'
            })
            _this.map.centerAndZoom(new BMap.Point(107.462033, 38.36023), 5)
            return false
          }
          res.data.data.pag[0].devId = res.data.data.pag[0].devId.toString()// 转成string防止丢失精度
          _this.watchDeviceList = res.data.data.pag
          console.log('====================', res.data.data.pag[0].devId.toString())
          console.log(' _this.watchDeviceList', _this.watchDeviceList)
          let lng = res.data.data.pag[0].lLonBd09 * 1
          let lat = res.data.data.pag[0].lLatBd09 * 1
          // await _this.popupGeocoder(res.data.data.pag[0].lLonBd09, res.data.data.pag[0].lLatBd09)
          let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29, 32, 33, 42, 43, 40]
          let shipKeyList = [6, 31]
          let angle = 0
          let electric = null
          if (res.data.data.pag[0].lElectricQuantity * 1 > 90) {
            electric = require('../../assets/images/电池/100.svg')
          } else if (res.data.data.pag[0].lElectricQuantity * 1 > 50) {
            electric = require('../../assets/images/电池/50-90.svg')
          } else if (res.data.data.pag[0].lElectricQuantity * 1 > 20) {
            electric = require('../../assets/images/电池/20-50.svg')
          } else {
            electric = require('../../assets/images/电池/0-20.svg')
          }
          let signalIntensityImg = null
          if (res.data.data.pag[0].lElectricQuantity * 1 > 29) {
            signalIntensityImg = require('../../assets/images/信号/29.svg')
          } else if (res.data.data.pag[0].lElectricQuantity * 1 > 22) {
            signalIntensityImg = require('../../assets/images/信号/22-28.svg')
          } else if (res.data.data.pag[0].lElectricQuantity * 1 > 15) {
            signalIntensityImg = require('../../assets/images/信号/15-21.svg')
          } else if (res.data.data.pag[0].lElectricQuantity * 1 > 8) {
            signalIntensityImg = require('../../assets/images/信号/8-14.svg')
          } else {
            signalIntensityImg = require('../../assets/images/信号/0-7.svg')
          }
          res.data.data.pag[0].coordinate =
            lng.toFixed(6) + ',' + lat.toFixed(6)

          var status = ''
          if (res.data.data.pag[0].status === 3) {
            status =
              (res.data.data.pag[0].lOpenAcc === 1 ? '点火' : '熄火') +
              ' ' +
              lImmediatelyStatusDic(res.data.data.pag[0].status)
            if (
              res.data.data.pag[0].offLineTimeStr !== null &&
              res.data.data.pag[0].offLineTimeStr !== ''
            ) {
              status = status + ' ' + res.data.data.pag[0].offLineTimeStr
            }
          } else {
            status =
              (res.data.data.pag[0].lOpenAcc === 1 ? '点火' : '熄火') +
              ' ' +
              lImmediatelyStatusDic(res.data.data.pag[0].status) +
              ' ' +
              res.data.data.pag[0].lSpeed / 10 +
              'Km/h'
          }
          var electricHtml = ''
          if (
            res.data.data.pag[0].lElectricQuantity != undefined &&
            res.data.data.pag[0].lElectricQuantity != null
          ) {
            electricHtml =
              '<td style="padding: 0">' +
              '<div style="float: left; margin-left: 5px"><img src="' +
              electric +
              '" style="height: 20px; width: 20px; margin-top: 9px"></div><div style="margin-top: 5px;float: left; line-height: 30px; font-size: 12px; margin-left: 5px">' +
              res.data.data.pag[0].lElectricQuantity +
              '%</div></td>'
          }
          var signalIntensity = ''
          if (
            res.data.data.pag[0].signalIntensity != undefined &&
            res.data.data.pag[0].signalIntensity != null
          ) {
            signalIntensity =
              '<td style="padding: 0">' +
              '<div style="float: left; margin-left: 10px"><img src="' +
              signalIntensityImg +
              '" style="height: 20px; width: 20px;margin-top: 5px"></div><div style="margin-top: 5px;float: left; line-height: 30px; font-size: 12px;">' +
              res.data.data.pag[0].signalIntensity +
              '</div></td>'
          }
          var voltage = ''
          if (
            res.data.data.pag[0].voltage != undefined &&
            res.data.data.pag[0].voltage != null
          ) {
            voltage =
              '<td style="padding: 0">' +
              '<div style="float: left; margin-left: 10px"><img src="' +
              require('../../assets/images/电压.svg') +
              '" style="height: 20px; width: 20px; margin-top: 5px"></div><div style="margin-top: 5px;float: left; line-height: 30px; font-size: 12px; ">' +
              res.data.data.pag[0].voltage +
              '</div></td>'
          }
          var satelliteNumber = ''
          if (
            res.data.data.pag[0].satelliteNumber != undefined &&
            res.data.data.pag[0].satelliteNumber != null
          ) {
            satelliteNumber =
              '<td style="padding: 0">' +
              '<div style="float: left; margin-left: 10px"><img src="' +
              require('../../assets/images/卫星.svg') +
              '" style="height: 20px; width: 20px; margin-top: 5px"></div><div style="margin-top: 5px;float: left; line-height: 30px; font-size: 12px; margin-left:5px">' +
              res.data.data.pag[0].satelliteNumber +
              '</div></td>'
          }

          res.data.data.pag[0].lRecordTime = res.data.data.pag[0].lRecordTime || '无'

          let html =
            '<div style="width: 300px; height: 260px; background-color: #FFFFFF; border-radius: 5px; box-shadow: 3px 3px 3px 3px #e8e8e8;">' +
            '<div style="width: 100%; height: 35px; border-radius: 5px 5px 0 0; border-bottom: #f1f1f1 solid 1px">' +
            '<table>' +
            '<tr>' +
            // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../../assets/images/电备份 3@2x.png') + '" style="height: 12px; width: 12px">15</td>' +
            // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../../assets/images/编组 6@2x.png') + '" style="height: 12px; width: 12px">5</td>' +

            electricHtml +
            signalIntensity +
            voltage +
            satelliteNumber +
            // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../../assets/images/SIM 流量卡.png') + '" style="height: 12px; width: 12px"></td>' +
            '</tr>' +
            '</table>' +
            '</div>' +
            '<div style="width: 70%; float: right; padding: 10px 20px 0 20px">' +
            '<table>' +
            '<tr>' +
            '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备名称:</span></td>' +
            '<td><span style="font-size: 12px">' +
            res.data.data.pag[0].devName +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<tr>' +
            '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备状态:</span></td>' +
            '<td><span style="font-size: 12px">' +
            status +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备编号:</span></td>' +
            '<td><span style="font-size: 12px">' +
            res.data.data.pag[0].devImei +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="width: 55px; margin-bottom:20px;"><span style="font-weight: bold; font-size: 12px">定位时间:</span></td>' +
            '<td><span style="font-size: 12px">' +
            res.data.data.pag[0].lRecordTime +
            '</td>' +
            '</tr>' +
            '</table>' +
            '</div>' +
            '<div style="width: 90%; height: 70px; border-radius: 0 0 5px 5px; margin-top: 120px; padding: 0 15px">' +
            // '<span style="font-size: 12px; padding: 0 10px"><img src="' + locationImg + '" style="height: 12px; width: 10px; margin: 5px 5px 0 0">GPS(BDS) ' + _this.popupGeocoderAddress + '</span>' +
            '</div>' +
            '<div style="width: 100%; height: 35px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px">' +
            '<table>' +
            '<tr>' +
            '<td style="padding: 2px 8px; cursor: pointer">' +
            '<img src="' + require('../../assets/images/function/geofence.svg') + '" title="电子围栏" style="height: 20px; width: 20px" onclick="jumpToFence()"></td>' +
            '<td style="padding: 2px 8px; cursor: pointer">' +
            '<img src="' + require('../../assets/images/function/tracks.svg') + '" title="轨迹回放" style="height: 20px; width: 20px" onclick="jumpToReplay(' +
            res.data.data.pag[0].devImei +
            ')"></td>' +
            '<td style="padding: 2px 8px; cursor: pointer">' +
            '<img src="' + require('../../assets/images/function/rt-monitor.svg') + '" title="监控中心" style="height: 20px; width: 20px" onclick="jumpToMonitor(' +
            res.data.data.pag[0].devImei + ',' + res.data.data.pag[0].devId +
            ')"></td>' +
            '<td style="padding: 2px 8px; cursor: pointer">' +
            '<img src="' + require('../../assets/images/menuIcon/车辆管理.png') + '" title="告警记录" style="height: 20px; width: 20px" onclick="jumpToWarning(\'' +
            res.data.data.pag[0].devName +
            "')\"></td>" +
            '<td style="padding: 2px 8px; cursor: pointer">' +
            '<img src="' + require('../../assets/images/index/反馈.png') + '" title="详情" style="height: 20px; width: 20px" onclick="jumpToDetails(' +
            res.data.data.pag[0].devImei +
            ')"></td>' +
            '</tr>' +
            '</table>' +
            '</div>' +
            '</div>'
          if (_this.infoBox === null) {
            _this.infoBox = new BMapLib.InfoBox(_this.map, html, {
              id: 'infobox',
              boxStyle: {
                width: '300px',
                height: '260px'
              },
              offset: new BMap.Size(10, 30),
              closeIconUrl: require('../../assets/images/closeInfoBox.png'),
              closeIconMargin: '10px 10px 0 0',
              enableAutoPan: true
            })
          }
          let icon = _this.$cautionIconFun.setIconAndPopupHtmlBDMap(
            _this,
            res.data.data.pag[0]
          )
          if (
            _this.watchDevMarker !== null &&
            _this.watchDevMarker.id === devId
          ) {
            if (
              carKeyList.indexOf(res.data.data.pag[0].devModel) > -1 ||
              shipKeyList.indexOf(res.data.data.pag[0].devModel) > -1
            ) {
              angle = res.data.data.pag[0].lDirection
            }
            _this.infoBox.setContent(html)
            _this.infoBox.setPosition(
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              )
            )
            _this.watchDevMarker.setPosition(
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              )
            )
            _this.watchDevMarker.setIcon(icon)
            _this.watchDevMarker.setRotation(angle)
            // 拼接轨迹线数据，以防重复绘制
            if (_this.watchPolyList.length >= 2) {
              _this.watchPolyList.shift()
            }
            _this.watchPolyList.push(
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              )
            )
            let test = new BMap.Polyline(_this.watchPolyList, {
              strokeColor: '#1a64d3',
              clip: false,
              strokeWeight: 2,
              setStrokeOpacity: 0.5,
              strokeOpacity: 1
            })
            _this.map.addOverlay(test)
            console.log(
              '12312321321321321',
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              )
            )

            _this.map.centerAndZoom(
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              ),
              19
            )
            // 当点超出视野范围，调整地图可视区域
            if (
              !_this.map
                .getBounds()
                .containsPoint(
                  new BMap.Point(
                    res.data.data.pag[0].lLonBd09,
                    res.data.data.pag[0].lLatBd09
                  )
                )
            ) {
              // _this.map.panTo(new BMap.Point(res.data.data.pag[0].lLonBd09, res.data.data.pag[0].lLatBd09))
              _this.map.centerAndZoom(
                new BMap.Point(
                  res.data.data.pag[0].lLonBd09,
                  res.data.data.pag[0].lLatBd09
                ),
                19
              )
            }
          } else if (_this.watchDevMarker === null) {
            if (
              carKeyList.indexOf(res.data.data.pag[0].devModel) > -1 ||
              shipKeyList.indexOf(res.data.data.pag[0].devModel) > -1
            ) {
              angle = res.data.data.pag[0].lDirection
            }
            _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlBDMap(
              _this,
              res.data.data.pag[0]
            )
            _this.watchDevMarker = new BMap.Marker(
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              ),
              {
                icon: _this.icon,
                rotation: angle
              }
            )
            _this.watchDevMarker.id = res.data.data.pag[0].devId
            _this.watchPolyList.push(
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              )
            )
            // _this.watchDevMarker.setZIndex(999)
            _this.map.addOverlay(_this.watchDevMarker)

            // 确保在添加标记后再打开弹窗，避免因标记未添加到地图而失败
            setTimeout(() => {
              if (_this.infoBox && _this.watchDevMarker) {
                _this.infoBox.open(_this.watchDevMarker);
              }
            }, 100);
            _this.map.centerAndZoom(
              new BMap.Point(
                res.data.data.pag[0].lLonBd09,
                res.data.data.pag[0].lLatBd09
              ),
              19
            )
            // 当点超出视野范围，调整地图可视区域
            if (
              !_this.map
                .getBounds()
                .containsPoint(
                  new BMap.Point(
                    res.data.data.pag[0].lLonBd09,
                    res.data.data.pag[0].lLatBd09
                  )
                )
            ) {
              // _this.map.panTo(new BMap.Point(res.data.data.pag[0].lLonBd09, res.data.data.pag[0].lLatBd09))
              _this.map.centerAndZoom(
                new BMap.Point(
                  res.data.data.pag[0].lLonBd09,
                  res.data.data.pag[0].lLatBd09
                ),
                19
              )
            }
          }
          console.log('length', _this.watchPolyList.length)
          console.log('watchPolyList', _this.watchPolyList)
          if (_this.watchPolyList != null && _this.watchPolyList.length > 1) {
            // 留下轨迹点，带方向
            _this.map.addOverlay(
              new BMap.Marker(
                new BMap.Point(
                  _this.watchPolyList[_this.watchPolyList.length - 2].lng,
                  _this.watchPolyList[_this.watchPolyList.length - 2].lat
                ),
                {
                  icon: new BMap.Icon(
                    require('../../assets/images/linePoint.png'),
                    new BMap.Size(16, 16),
                    {
                      imageSize: new BMap.Size(16, 16)
                    }
                  ),
                  rotation: res.data.data.pag[0].lDirection
                }
              )
            )
          }

          _this.watchDevMarker.addEventListener('click', () => {
            _this.infoBox.open(_this.watchDevMarker)
          })
        } else {
          console.log(res)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
}
export default trackingCtl



// WEBPACK FOOTER //
// ./src/javascript/function/trackingFunction.js